import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { DraftList } from '../interfaces/draft';
import { API_ENDPOINTS } from 'app/core/constants/api-endpoints.constant';
import { ApiService } from 'app/shared/constant/api-service/api.service';

@Injectable({
    providedIn: 'root',
})
export class ApplicationDashboardService {
    constructor(
        private _httpClient: HttpClient,
        private _apiService: ApiService
    ) {}

    getDrafts(): Observable<DraftList> {
        return this._apiService
            .get(`${API_ENDPOINTS.GET_DRAFTS}`)
            .pipe(catchError(this.handleError));
    }

    deleteDrafts(data: any): Observable<string> {
        return this._apiService
            .post(`${API_ENDPOINTS.DELETE_DRAFTS}`, data)
            .pipe(catchError(this.handleError));
    }

    caseStatus(): Observable<any> {
        return this._apiService
            .get(`${API_ENDPOINTS.GET_CASE_STATUS}`)
            .pipe(catchError(this.handleError));
    }

    getOldCaseStatus(): Observable<any> {
        return this._apiService
            .get(`${API_ENDPOINTS.GET_CASE_STATUS}?oldcase`)
            .pipe(catchError(this.handleError));
    }

    generateOTP(data): Observable<any> {
        return this._apiService
            .post(`${API_ENDPOINTS.GENERATE_OTP}`, data)
            .pipe(catchError(this.handleError));
    }

    // getCases(): Observable<any>{

    // }

    handleError(error: HttpErrorResponse): Observable<any> {
        if (error.error instanceof ErrorEvent) {
            return throwError('Network Error');
        } else if (error.status == 404) {
            return throwError('Not Found');
        } else if (error.status == 400) {
            return throwError('Bad Request');
        }
        return throwError('Something went wront please try again');
    }
}
